// @ts-nocheck
import clsx from 'clsx'
import {Column} from 'react-table'
import {Model} from '@/_metronic/helpers'
import {
  TextCell,
  CountryCell,
  ActionsCell,
  CustomHeader
} from '@/components/table/columns'

import {OverviewCell, StatusCell, StockCell, TypeCell} from './ProductCells'
import {BrandCell} from '../../../_components/columns/BrandCell'

const Columns: ReadonlyArray<Column<Model>> = [{
  Header: (props) => <CustomHeader tableProps={props} title='Name' className='min-w-70px sortable' />,
  id: 'name',
  Cell: ({...props}) => (
    <OverviewCell
      name={props.data[props.row.index].name}
      cover={props.data[props.row.index].cover}
      id={props.data[props.row.index]._id}
    />
  )
}, {
  Header: (props) => <CustomHeader tableProps={props} title='SKU' className='min-w-70px text-end pe-0 sortable' />,
  id: 'sku',
  className: 'text-end pe-0',
  Cell: ({...props}) => <TextCell content={props.data[props.row.index].sku} />,
}, {
  Header: (props) => <CustomHeader tableProps={props} title='BRAND' className='min-w-70px text-center pe-0' />,
  id: 'brand',
  className: 'text-center pe-0',
  Cell: ({...props}) => <BrandCell brand={props.data[props.row.index].brand} />
}, {
  Header: (props) => <CustomHeader tableProps={props} title='TYPE' className='min-w-125px text-end pe-0 sortable' />,
  id: 'type',
  className: 'text-end pe-0',
  Cell: ({...props}) => <TypeCell type={props.data[props.row.index].type} />,
}, {
  Header: (props) => <CustomHeader tableProps={props} title='REGION' className='text-center min-w-70px sortable' />,
  id: 'region',
  className: 'text-center',
  Cell: ({...props}) => <CountryCell countryCode={props.data[props.row.index].region} />,
}, {
  Header: (props) => <CustomHeader tableProps={props} title='Status' className='text-center min-w-70px sortable' />,
  id: 'status',
  className: 'text-center',
  Cell: ({...props}) => <StatusCell status={props.data[props.row.index].status} />,
}, {
  Header: (props) => <CustomHeader tableProps={props} title='Stock' className='min-w-70px text-end pe-0 sortable' />,
  id: 'stock',
  className: 'text-end pe-0',
  Cell: ({...props}) => <StockCell stock={props.data[props.row.index].stock} threshold={props.data[props.row.index].threshold} />,
}, {
  Header: (props) => <CustomHeader tableProps={props} title='CREDITS' className='min-w-125px text-end pe-0 sortable' />,
  id: 'credits',
  className: 'text-end pe-0',
  Cell: ({...props}) => <TextCell content={props.data[props.row.index].credits} />,
}, {
  Header: (props) => <CustomHeader tableProps={props} title='SUPPLIERS' className='min-w-125px text-center pe-0' />,
  id: 'suppliers',
  className: 'text-center pe-0',
  Cell: ({...props}) => (
    <TextCell
      content={props.data[props.row.index].suppliers}
      className={clsx('badge badge-circle', {
        'badge-primary': props.data[props.row.index].suppliers > 0,
        'badge-danger': props.data[props.row.index].suppliers === 0,
      })}
    />
  )
}, {
  Header: (props) => (
    <CustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />
  ),
  id: 'actions',
  Cell: ({...props}) => (
    <ActionsCell
      itemForUpdate={props.data[props.row.index]}
      actions={[{
        icon: 'magnifier',
        //icon: 'exit-right-corner',
        label: 'View',
        navigate:  `/p2c/product/${props.data[props.row.index]._id}/overview`
      }, {
        icon: 'copy',
        label: 'Create copy',
        openModal: 'copy'
      }]}
    />
  )
}]

export {Columns}
